import {useListSaleVehiclePhotosByVehicleQuery} from '@dms/api/vehicle';

export function useListingPhotos(vehicleId: string) {
  const {data} = useListSaleVehiclePhotosByVehicleQuery({vehicleId});
  return [...(data?.photos ?? [])].sort((first, second) => first.weight - second.weight);
}
